// sizing

export default {
  breakpoints: ["40em", "52em", "64em"],
  // space: [0, 4, 8, 12, 16, 32, 48, 64, 72, 128, 256, 512],
  // space: [0, 4, 8, 16, 32, 64, 128, 256, 512],

  // space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  // num [0, 1, 2,  3,  4,  5, 6,  7,   8,   9,   10,   11]
  space: [0, 4, 8, 12, 24, 32, 36, 60, 100, 120, 180, 200],
  sizes: {
    borderWidth: [1, 2],
    secondLastBorderWidth: [1, 0],
    tagRadiiSquared: "6px",
    tagRadii: "50px",
    container: 1200,
  },
}
